


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

function AdminApprovalPage() {
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [searchQuery, setSearchQuery] = useState(""); // 🔍 New Search State
  const navigate = useNavigate();

  // 🖱️ Mouse Tracking for Spotlight effect
  useEffect(() => {
    const handleMouseMove = (e) => setMousePos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await API.get("/logs/bhr-approved");
      setAgents(res.data || []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };


  const handleReject = async (id) => {
    const reason = prompt("Enter reject reason:");

    if (!reason) return;

    try {
      const formData = new FormData();
      formData.append("reason", reason);

      await API.post(`logs/admin/reject/${id}`, formData);

      alert("❌ Rejected by Admin");
      setSelectedAgent(null);
      fetchData();

    } catch (err) {
      console.error(err);
      alert("❌ Failed to reject");
    }
  };

  // 🔍 Filter Logic
  const filteredAgents = agents.filter((agent) => {
    const term = searchQuery.toLowerCase();
    return (
      agent.name?.toLowerCase().includes(term) ||
      agent.email?.toLowerCase().includes(term) ||
      agent.mobile?.toLowerCase().includes(term) ||
      agent.id?.toString().includes(term)
    );
  });

  const handleApprove = async () => {
    if (!selectedAgent) return;

    const confirm = window.confirm(
      "Generate Comm Code and Approve this agent?"
    );

    if (!confirm) return;

    try {
      setLoading(true);
      const res = await API.post(`/logs/admin-approve/${selectedAgent.id}`);
      alert(`✅ Approved\nCode: ${res.data.comm_code}`);
      setSelectedAgent(null);
      fetchData();
    } catch (err) {
      alert("❌ Failed to finalize approval");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page-wrapper">
      <style>{`
        .admin-page-wrapper {
          min-height: 100vh; background: #020617; color: white;
          font-family: 'Plus Jakarta Sans', sans-serif; padding: 40px 20px;
          position: relative; overflow-x: hidden;
        }
        .spotlight {
          position: fixed; top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at ${mousePos.x}px ${mousePos.y}px, rgba(99, 102, 241, 0.08) 0%, transparent 50%);
          z-index: 1; pointer-events: none;
        }
        .container { max-width: 1400px; margin: 0 auto; position: relative; z-index: 2; }
        
        .logs-header { text-align: center; margin-bottom: 40px; padding: 0 10px; }
        .logs-header h1 { 
          font-size: clamp(24px, 5vw, 36px); font-weight: 800; letter-spacing: -1px;
          background: linear-gradient(to right, #fff, #94a3b8);
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
        }
        .logs-header p { color: #64748b; margin-top: 8px; }

        /* 🔍 SEARCH STYLING */
        .search-container {
          margin-bottom: 30px;
          display: flex;
          justify-content: center;
        }
        .search-input {
          width: 100%;
          max-width: 600px;
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.1);
          padding: 16px 24px;
          border-radius: 16px;
          color: white;
          font-size: 15px;
          outline: none;
          transition: 0.3s;
          backdrop-filter: blur(10px);
        }
        .search-input:focus {
          border-color: #6366f1;
          background: rgba(255, 255, 255, 0.06);
          box-shadow: 0 0 20px rgba(99, 102, 241, 0.15);
        }

        .glass-card {
          background: rgba(255, 255, 255, 0.02); backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 24px; padding: clamp(15px, 3vw, 24px);
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
          overflow: hidden;
        }

        .table-wrapper { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; }
        .logs-table { width: 100%; border-collapse: separate; border-spacing: 0 10px; min-width: 850px; }
        .logs-table th { padding: 16px; text-align: left; color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 1px; }
        .logs-table td { padding: 18px; background: rgba(255, 255, 255, 0.03); font-size: 14px; border-top: 1px solid rgba(255,255,255,0.05); }
        .logs-table td:first-child { border-radius: 12px 0 0 12px; }
        .logs-table td:last-child { border-radius: 0 12px 12px 0; }
        
        .status.bhr_approved { 
          background: rgba(99, 102, 241, 0.15); color: #818cf8; 
          padding: 6px 12px; border-radius: 8px; font-size: 11px; font-weight: 700; display: inline-block;
        }

        .btn.approve {
          background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
          color: white; border: none; padding: 10px 20px; white-space: nowrap;
          border-radius: 12px; font-weight: 700; cursor: pointer;
          transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(79, 70, 229, 0.3);
        }
        .btn.approve:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(79, 70, 229, 0.4); }

        .fullscreen-modal {
          position: fixed; top: 0; left: 0; width: 100%; height: 100%;
          background: #020617; z-index: 1000; display: flex; flex-direction: column;
        }
        .fs-header {
          padding: 15px 25px; display: flex; justify-content: space-between; align-items: center;
          border-bottom: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02);
        }
        .fs-header h2 { font-weight: 700; color: #f8fafc; font-size: clamp(16px, 4vw, 22px); }
        .fs-body { display: grid; grid-template-columns: 1fr 400px; flex: 1; overflow: hidden; }
        .fs-pdf { background: #0f172a; padding: 15px; display: flex; flex-direction: column; }
        .fs-pdf iframe { flex: 1; border-radius: 16px; border: 1px solid rgba(255,255,255,0.1); width: 100%; }
        .fs-side {
          padding: 30px; border-left: 1px solid rgba(255,255,255,0.1);
          overflow-y: auto; background: rgba(255,255,255,0.01);
        }
        .fs-side h3 { margin-bottom: 24px; color: #818cf8; font-size: 20px; }
        .info-box { background: rgba(255,255,255,0.03); padding: 20px; border-radius: 16px; margin-bottom: 30px; }
        .info-box p { margin-bottom: 12px; font-size: 15px; color: #94a3b8; }
        .info-box b { color: white; }

        .back-btn-fixed {
          position: fixed; bottom: 20px; left: 20px;
          width:20rem;
          padding: 12px 24px; background: rgba(255, 255, 255, 0.05); 
          backdrop-filter: blur(12px); border: 1px solid rgba(255, 255, 255, 0.1); 
          color: #94a3b8; border-radius: 12px; cursor: pointer; z-index: 100;
          display: flex; align-items: center; gap: 8px; font-weight: 600;
          transition: all 0.3s ease;
        }
        .back-btn-fixed:hover { background: rgba(255, 255, 255, 0.1); color: white; transform: translateY(-3px); }

        .approve-btn {
          width: 100%; padding: 18px; border-radius: 16px; border: none;
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          color: white; font-weight: 800; font-size: 16px; cursor: pointer;
          transition: 0.3s; box-shadow: 0 10px 20px rgba(34, 197, 94, 0.2);
        }
        .approve-btn:hover:not(:disabled) { transform: scale(1.02); }
        .approve-btn:disabled { opacity: 0.5; cursor: not-allowed; }
        .close-btn { 
          background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); 
          color: white; width: 40px; height: 40px; border-radius: 12px; cursor: pointer; 
        }

        @media (max-width: 1024px) {
          .fs-body { grid-template-columns: 1fr; overflow-y: auto; }
          .fs-pdf { height: 500px; flex: none; }
          .fs-side { border-left: none; border-top: 1px solid rgba(255,255,255,0.1); }
          .back-btn-fixed { padding: 10px 15px; font-size: 12px; min-width: 120px; }
        }

        @media (max-width: 600px) {
          .admin-page-wrapper { padding: 20px 10px; }
          .logs-header { margin-bottom: 20px; }
          .fs-header { padding: 10px 15px; }
          .fs-pdf { height: 350px; }
          .fs-side { padding: 20px; }
          .approve-btn { padding: 14px; font-size: 14px; }
        }


.reject-btn {
  width: 100%;
  padding: 18px;
  margin-top: 15px;
  border-radius: 16px;
  border: none;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  font-weight: 800;
  font-size: 16px;
  cursor: pointer;
  transition: 0.3s;
  box-shadow: 0 10px 20px rgba(239, 68, 68, 0.2);
}

.reject-btn:hover:not(:disabled) {
  transform: scale(1.02);
}

.reject-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}


      `}</style>

      <div className="spotlight"></div>

      <button className="back-btn-fixed" onClick={() => navigate("/dashboard")}>
        <span>←</span> <span>Dashboard</span>
      </button>

      <div className="container">
        <header className="logs-header">
          <h1>🛡 Admin Approval Panel</h1>
          <p>Review BHR-cleared documents and generate commercial codes</p>
        </header>

        {/* 🔍 Search Input Field */}
        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Search by name, email, contact or ID..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="glass-card">
          <div className="table-wrapper">
            <table className="logs-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Contact Info</th>
                  <th>Status</th>
                  <th>Timestamps</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredAgents.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center", padding: "60px", color: "#64748b" }}>
                      {agents.length === 0
                        ? "🚫 No agents currently awaiting Admin approval"
                        : "🔍 No matching agents found"}
                    </td>
                  </tr>
                ) : (
                  filteredAgents.map((a) => (
                    <tr key={a.id}>
                      <td style={{ fontWeight: "600" }}>{a.name}</td>
                      <td>
                        <div style={{ fontSize: "13px" }}>{a.email}</div>
                        <div style={{ fontSize: "12px", color: "#64748b" }}>{a.mobile}</div>
                      </td>
                      <td>
                        <span className="status bhr_approved">
                          {a.status?.replace("_", " ")}
                        </span>
                      </td>
                      <td>
                        <div style={{ fontSize: "11px", color: "#94a3b8" }}>
                          Signed: {a.submission_time ? new Date(a.submission_time).toLocaleDateString() : "-"}
                        </div>
                        <div style={{ fontSize: "11px", color: "#818cf8" }}>
                          BHR: {a.bhr_time ? new Date(a.bhr_time).toLocaleDateString() : "-"}
                        </div>
                      </td>
                      <td>
                        <button
                          className="btn approve"
                          onClick={() => setSelectedAgent(a)}
                        >
                          ⚡ Generate Code
                        </button>




                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* 🔥 FULLSCREEN MODAL */}
      {selectedAgent && (
        <div className="fullscreen-modal">
          <div className="fs-header">
            <h2>📄 Final Authorization: {selectedAgent.name}</h2>
            <button className="close-btn" onClick={() => setSelectedAgent(null)}>✕</button>
          </div>

          <div className="fs-body">
            <div className="fs-pdf">
              {selectedAgent?.pdf?.startsWith("/files") ? (
                <iframe
                  src={`https://vgmconsult.net/api${selectedAgent.pdf}`}
                  title="PDF Preview"
                />
              ) : (
                <div style={{ textAlign: "center", color: "#ef4444", marginTop: "20%" }}>
                  ❌ Document preview unavailable ({selectedAgent?.pdf})
                </div>
              )}
            </div>

            <div className="fs-side">
              <h3>Administrator Review</h3>

              <div className="info-box">
                <p><b>Agent Name:</b> {selectedAgent.name}</p>
                <p><b>Email:</b> {selectedAgent.email}</p>
                <p><b>Mobile:</b> {selectedAgent.mobile}</p>
                <p><b>BHR Status:</b> Verified ✅</p>
              </div>

              <div style={{ marginBottom: '30px' }}>
                <p style={{ fontSize: '14px', color: '#94a3b8', lineHeight: '1.6' }}>
                  By clicking below, you will generate a unique <b>Commercial Code</b> for this agent and finalize their onboarding process in the system.
                </p>
              </div>

              <button
                className="approve-btn"
                onClick={handleApprove}
                disabled={loading}
              >
                {loading ? "⚙ Generating Code..." : "🚀 Generate Code & Approve"}
              </button>


              <button
                className="reject-btn"
                onClick={() => handleReject(selectedAgent.id)}
                disabled={
                  selectedAgent.status === "admin_approved" ||
                  selectedAgent.status === "admin_rejected"
                }
              >
                ❌ Reject
              </button>
              <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '12px', color: '#475569' }}>
                ID: {selectedAgent.id}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminApprovalPage;